import { put } from 'redux-saga/effects'
import triggerAPI from "../services/triggerApi";
import { endpoints } from '../services/endpoints';
import { ELSS_Data_RESPONSE, ELSS_Data_RESPONSE_FAIL, ELSS_PDFDOWNLOAD_RESPONSE, ELSS_PDFDOWNLOAD_RESPONSE_FAIL } from '../redux/types/elssReport';

const call = new triggerAPI();

export function* elssData({ payload, resolve }) {
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reportsV2.elssReportData);
        if (data?.success) {
            yield put({ type: ELSS_Data_RESPONSE, payload: data?.data?.finyears })
            resolve && resolve(data?.data?.finyears)
        } else {
            resolve && resolve(data)
            yield put({ type: ELSS_Data_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: ELSS_Data_RESPONSE_FAIL, payload: e.toString() })
    }
}

export function* elssPdfDownload({ payload, resolve }) {
    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reportsV2.elssReportPdfDownload);
        if (data?.success) {
            yield put({ type: ELSS_PDFDOWNLOAD_RESPONSE, payload: data.data })
            resolve && resolve(data.data)
        } else {
            resolve && resolve(data)
            yield put({ type: ELSS_PDFDOWNLOAD_RESPONSE_FAIL, payload: data })
        }
    } catch (e) {
        yield put({ type: ELSS_PDFDOWNLOAD_RESPONSE_FAIL, payload: e.toString() })
    }
}
